"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseWeb3Multicall3 = void 0;
const AbiCoder = __importStar(require("web3-eth-abi"));
const call_failed_error_js_1 = require("./errors/call-failed.error.js");
const create_contract_call_js_1 = require("./create-contract-call.js");
class BaseWeb3Multicall3 {
    constructor(contract) {
        this.contract = contract;
        this.createContractCall = create_contract_call_js_1.createContractCall;
    }
    aggregate3(methods) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = methods.map((method) => {
                const callData = AbiCoder.encodeFunctionCall(method.abi, method.args);
                return {
                    target: method.address,
                    callData,
                    allowFailure: true,
                };
            });
            const result = yield this.contract.methods.aggregate3(params).call();
            const response = result.map(({ success, returnData }, i) => {
                var _a;
                if (!success) {
                    return new call_failed_error_js_1.CallFailedError(`i=${i}`);
                }
                const { abi } = methods[i];
                const decoded = AbiCoder.decodeParameters(abi.outputs, returnData);
                return ((_a = abi.outputs) === null || _a === void 0 ? void 0 : _a.length) === 1 ? decoded[0] : decoded;
            });
            return response;
        });
    }
}
exports.BaseWeb3Multicall3 = BaseWeb3Multicall3;
